import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  saveFilterGroup: [],
  currentAppliedSavedFilterName: '',
  savedFiltersList: [],
  currentFilterCombinationName: '',
  filterChangesFromSavedFilter: false
}

const SavedFilterSlice = createSlice({
  name: 'savedFilter',
  initialState,
  reducers: {
    // Add a single new filter to the list
    addSavedFilter: (state, action) => {
      state.saveFilterGroup = action.payload
      state.savedFiltersList.push(action.payload)
    },

    // Set Current Applied Saved Filter Name
    setCurrentAppliedSavedFilterName: (state, action) => {
      state.currentAppliedSavedFilterName = action.payload
    },

    // Replace entire list (from API)
    setEntireSavedFiltersList: (state, action) => {
      state.savedFiltersList = action.payload
    },

    // Update a saved filter name
    updateSavedFilterName: (state, action) => {
      const {oldName, newName} = action.payload
      state.savedFiltersList = state.savedFiltersList.map((filter) =>
        filter.name === oldName ? {...filter, name: newName} : filter
      )
    },

    // Delete a saved filter
    deleteSavedFilter: (state, action) => {
      state.savedFiltersList = state.savedFiltersList.filter((f) => f.name !== action.payload)
      // Clear applied filter name if it was deleted
      if (state.currentAppliedSavedFilterName === action.payload) {
        state.currentAppliedSavedFilterName = ''
      }
    },

    // Set current filter combination name (used for checking duplicates) and pointing to SaveFilters Group
    setCurrentFilterCombinationName: (state, action) => {
      state.currentFilterCombinationName = action.payload
    },

    setFilterChangesFromSavedFilter: (state, action) => {
      state.filterChangesFromSavedFilter = action.payload
    }
  }
})

export const {
  addSavedFilter,
  setCurrentAppliedSavedFilterName,
  setEntireSavedFiltersList,
  updateSavedFilterName,
  deleteSavedFilter,
  setCurrentFilterCombinationName,
  setFilterChangesFromSavedFilter
} = SavedFilterSlice.actions

export const selectSaveFilterGroup = (state) => state.savedFilter?.saveFilterGroup ?? []
export const selectCurrentAppliedSavedFilterName = (state) => state.savedFilter?.currentAppliedSavedFilterName ?? ''
export const selectSavedFiltersList = (state) => state.savedFilter?.savedFiltersList ?? []
export const selectCurrentFilterCombinationName = (state) => state.savedFilter?.currentFilterCombinationName ?? ''
export const selectFilterChangesFromSavedFilter = (state) => state.savedFilter?.filterChangesFromSavedFilter ?? false

export default SavedFilterSlice.reducer
